import { required } from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';

export default {
    mixins: [abstractValidatorMixin],
    data() {
        return {
            serverErrors: {
                isThemeDark: [],
                dateFormat: [],
                timeZone: [],
                language: []
            }
        };
    },
    validations: {
        formData: {
            isThemeDark: { required },
            dateFormat: { required },
            timeZone: { required },
            language: { required }
        }
    },
    computed: {
        isThemeDarkErrors() {
            return this.checkErrors('isThemeDark');
        },
        dateFormatErrors() {
            return this.checkErrors('dateFormat');
        },
        timeZoneErrors() {
            return this.checkErrors('timeZone');
        },
        languageErrors() {
            return this.checkErrors('language');
        }
    }
};
